import { Typography } from '@mui/material';
import React from 'react';

export const PaywallCardPlanText = ({ text }: { text: string }) => {
  return (
    <Typography
      variant="body1"
      sx={{
        color: 'text.secondary',
      }}
    >
      {text}
    </Typography>
  );
};
